module.exports = __webpack_public_path__ + "img/ruan3.f7181957.jpg";